import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

const store = new Vuex.Store({
    strict: false,
    plugins: [vuexLocal.plugin],
    state: {
      languageValue: localStorage.getItem('languageValue') || 'zh'

    },
    
    getters: {
      getlanguage(state){
        return state.languageValue
      }
    },
    mutations: {
      setLanguage(state, languageValue) {
        state.languageValue = languageValue;
      }
    },
    actions:{
      changelanguageValue({ commit }, languageValue) {
        commit('setLanguage', languageValue);
      }
    }
})

export default store